<template>
    <div v-if="!loading" class="card mb-4">
        <div class="card-body" v-if="report.length === 0">Rapport "{{ this.identifier }}" is niet beschikbaar </div>
        <div class="card-body" v-for="(item, index) in report" :key="'report_item_' + index">
            <iframe class="metabase" :class="item.css_class" :src="item.url + '#bordered=false'" :height="(item.height ? item.height : '400') + 'px'" width="100%"></iframe>
        </div>
    </div>
    <div v-else class="card mb-4">
        <div class="card-body"><font-awesome-icon icon="spinner" spin/></div>
    </div>
</template>

<script>
export default {
    name: 'metabase',

    props: {
        identifier: {required: true},
        parameters: {required: false},
    },

    data() {
        return {
            report: [],
            loading: true
        }
    },

    mounted() {
        this.$http.get(`/api/pim/metabase/${this.identifier}`, {
            params: this.parameters
        }).then((response) => {
            this.report = response.data;
            this.loading = false
        });
    }

}
</script>

<style>
.metabase {
    border: none;
    width: 100%;
}
</style>
